<template>
  <b-modal
    ref="switchServerVisibility"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable
    @hidden="unselectServer()">

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        Hiding the server «<span class="font-weight-bold">{{ selectedServer.name }}</span>»  will hide it from the general list of servers for the user/reseller without losing user accounts to the VPN server. The user will be able to connect regardless of this status if the config from the VPN server was previously downloaded.
      </p>
    </b-alert>

    <div class="font-weight-bold mb-2">Server Details</div>
    <b-list-group
      v-if="selectedServerId !== null"
      class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        Name
        <span class="ml-auto">{{ selectedServer.name }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Location
        <span class="ml-auto">
          <div class="d-flex align-items-center">
            <img
              :src="countryFlag(selectedServer.country)"
              :alt="selectedServer.country"
              class="w-20px mr-2 no-select rounded-sm bg-light border border-light rounded-sm" />
            <span
              class="d-inline-block mr-1 text-truncate"
              style="max-width: 180px;">{{ countryName(selectedServer.country) }}, {{ selectedServer.location }}</span>
          </div>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        IP
        <span class="ml-auto">{{ selectedServer.ip }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Status
        <span class="ml-auto font-size-xs">
          <b-badge :variant="serverStatusBadge(selectedServer).variant">
            <i :class="`fa fa-sm fa-${serverStatusBadge(selectedServer).icon} text-white`"></i>
            {{ serverStatusBadge(selectedServer).text }}
          </b-badge>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Client Version
        <span class="ml-auto">
          <span v-if="selectedServer.client_version">
            <span class="font-size-xs">v</span>
            <span>{{ selectedServer.client_version }}</span>
          </span>
          <i
            v-else
            class="fa fa-minus fa-xs opacity-50" />
        </span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('switchServerVisibility')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="serversResponses('switchServer')"
          @click="switchServerVisibility(), hideModal('switchServerVisibility')">
          Yes, hide it
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  SWITCH_SERVER_VISIBILITY,
  UNSELECT_SERVER
} from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalShutdownServer',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'countryFlag',
      'countryName',

      'selectedServer',
      'selectedServerId',
      'serverStatusBadge',
      'serversResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectServer() {
      this.$store.commit(UNSELECT_SERVER)
    },

    switchServerVisibility() {
      this.$store.dispatch(SWITCH_SERVER_VISIBILITY, {
        id: this.selectedServerId,
        action: 'hide'
      })
    }
  }
}
</script>
